import script from "./ManagementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementTable.vue?vue&type=script&setup=true&lang=js"

import "./ManagementTable.vue?vue&type=style&index=0&id=6bda605e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bda605e"]])

export default __exports__